import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListProjects from '../../project/list-projects';
import Header from '../../common/components/header';
import Sidebar from '../../common/components/sidebar';
const ProjectRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/" element={<ListProjects />} />
          </Routes>
        </div>
      </div>

      <>Some Footer Stuff</>
    </>
  );
};

export default ProjectRoutes; 

